export default __webpack_public_path__ + "static/media/certificate_third.fb208cb7.jpg";